import { useUserContext } from '@/context'

export enum AccessLevel {
  AGM = 'AGM',
  BILLING = 'BILLING',
  HOME_BLOCK_PERMITTED = 'HOME_BLOCK_PERMITTED',
  HUB_MANAGER = 'HUB_MANAGER',
  SUPER_ADMIN = 'SUPER_ADMIN',
  X_TEAM = 'X_TEAM',
}

interface UseAccessLevelReturn {
  accessGranted: (allowedAccessLevels: AccessLevel[]) => boolean
}

export const useAccessLevel = (): UseAccessLevelReturn => {
  const { user } = useUserContext()

  const accessGranted = (allowedAccessLevels: AccessLevel[]): boolean => {
    if (!!user?.isSuperAdmin) {
      return true
    } else {
      return (
        (user?.isAgm && allowedAccessLevels.includes(AccessLevel.AGM)) ||
        (user?.isBilling && allowedAccessLevels.includes(AccessLevel.BILLING)) ||
        (user?.isHubManager && allowedAccessLevels.includes(AccessLevel.HUB_MANAGER)) ||
        (user?.isXteam && allowedAccessLevels.includes(AccessLevel.X_TEAM)) ||
        (user?.homeBlockPermitted && allowedAccessLevels.includes(AccessLevel.HOME_BLOCK_PERMITTED)) ||
        false
      )
    }
  }

  return { accessGranted }
}
